(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/poker-react/components/common/assets/javascripts/helpers.js') >= 0) return;  svs.modules.push('/modules/poker-react/components/common/assets/javascripts/helpers.js');
"use strict";


const {
  BrowserStorageConstants
} = svs.poker_react.components.common.constants;
const isMobile = svs.core.detect.formfactor.mobile();
const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
const {
  constants: {
    EXPIRES_10M
  },
  browser: BrowserStorage
} = svs.components.Storage;
const pokerHome = svs.core.urlMapping.get('pokerHome');
const handlePokerPlayEvent = function () {
  let label = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  svs.components.analytics.trackEvent({
    category: 'Poker',
    action: 'initiate poker',
    opt_label: label
  });
};
const launchWebClient = function () {
  let {
    gameLink,
    tournamentId
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const trackingLabel = gameLink !== null && gameLink !== void 0 ? gameLink : 'SPELA DIREKT';
  handlePokerPlayEvent(trackingLabel);
  if (!isLoggedIn) {
    BrowserStorage.set(BrowserStorageConstants.OpenWebClientKey, BrowserStorageConstants.Domain, {
      openWebClient: true
    }, EXPIRES_10M, () => {
      svs.components.customer_login.login();
    });
  } else {
    window.open("".concat(pokerHome, "/spela?formFactor=").concat(isMobile ? 'mobile' : 'desktop', "&gameLink=").concat(gameLink, "&tournamentId=").concat(tournamentId), '', 'popup');
  }
};
const helpers = {
  launchWebClient,
  handlePokerPlayEvent
};
setGlobal('svs.poker_react.components.common.helpers', helpers);

 })(window);